import { useState, useEffect } from "react";
import { Modal, Button, Form, Table } from "react-bootstrap";
import axios from "axios";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";

const getAuthToken = () => localStorage.getItem("authToken");

const BatchManagement = () => {
  const [batches, setBatches] = useState([]);
  const [classes, setClasses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ id: null, class_id: "", division: "" });

  useEffect(() => {
    fetchClasses();
    fetchBatches();
  }, []);

  const fetchClasses = async () => {
    const token = getAuthToken();
    if (!token) {
      alert("Unauthorized! Please log in.");
      return;
    }

    try {
      const response = await axios.get(`${appConstants.API_ROOT_URL}get-classes`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.status === "success") {
        setClasses(response.data.data);
      } else {
        alert("Failed to fetch classes");
      }
    } catch (error) {
      console.error("Failed to fetch classes", error);
      alert("Error fetching classes");
    }
  };

  const fetchBatches = async () => {
    const token = getAuthToken();
    if (!token) {
      alert("Unauthorized! Please log in.");
      return;
    }

    try {
      const response = await axios.get(`${appConstants.API_ROOT_URL}get-batches`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.status === "success") {
        setBatches(response.data.data);
      } else {
        alert("Failed to fetch batches");
      }
    } catch (error) {
      console.error("Failed to fetch batches", error);
      alert("Error fetching batches");
    }
  };

  const handleSave = async () => {
    const token = getAuthToken();
    if (!token) {
      alert("Unauthorized! Please log in.");
      return;
    }
  
    try {
      const url = formData.id
        ? `${appConstants.API_ROOT_URL}update-batch`
        : `${appConstants.API_ROOT_URL}create-batch`;
  
      const response = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      if (response.data.status === "success") {
        fetchBatches();
        setShowModal(false);
      } else {
        alert(response.data.message || "Failed to save batch");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred while saving the batch.";
      alert(errorMessage);
      console.error("Error saving batch:", error);
    }
  };
  

  const openModal = (batch = { id: null, class_id: "", division: "" }) => {
    // If editing, find the class_id using class_name
    const classData = classes.find(c => c.name === batch.class_name);
    setFormData({
      id: batch.id || null,
      class_id: classData ? classData.id : "", // Assign correct class_id
      division: batch.division || ""
    });
    setShowModal(true);
  };

  return (
    <Layout>
      <h2>Batch Management</h2>
      <Button variant="primary" onClick={() => openModal()}>Add Batch</Button>
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>Sl</th>
            <th>Class</th>
            <th>Division</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {batches.map((batch, index) => (
            <tr key={batch.id}>
              <td>{index + 1}</td>
              <td>{batch.class_name}</td> {/* Directly use class_name */}
              <td>{batch.division}</td>
              <td>
                <Button variant="warning" size="sm" onClick={() => openModal(batch)}>Edit</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{formData.id ? "Edit Batch" : "Add Batch"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Class</Form.Label>
              <Form.Select
                value={formData.class_id}
                onChange={(e) => setFormData({ ...formData, class_id: e.target.value })}
              >
                <option value="">Select Class</option>
                {classes.map((c) => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Division</Form.Label>
              <Form.Control
                type="text"
                value={formData.division}
                onChange={(e) => setFormData({ ...formData, division: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={handleSave}>Save</Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
};

export default BatchManagement;
